module.exports = __webpack_public_path__ + "static/media/3-4.4755a7b3.png";